<template>
  <div class="custom-vue-table-wrapper" style="width: 100%; overflow-x: scroll;">
    <div v-if="isLoading" class="table-loading-overlay">
      <div class="table-loading-spinner">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <div class="table-loading-text">{{ $t('Loading...') }}</div>
      </div>
    </div>
    <vuetable :api-mode="apiMode" @on="$listeners" :class="classes + ' custom-vue-table  text-nowrap'" :css="Object.assign(css.table,extraCss.table)"
   :api-url="apiUrl" :per-page="perPage" :data="dataVar" :row-class="onRowClass" :append-params="moreParams" :http-options="tokenHeader" @vuetable:checkbox-toggled="onCheckboxToggled" :fields="fields" @table-switch-event="onTableSwitchEvent" :data-path="dataPath" pagination-path="" ref="vuetable" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:load-success="loadSuccess" @vuetable:load-error="loadError" :detail-row-component="detailRowComponent" :detail-row-id="detailRowId" :track-by="trackBy" @vuetable:cell-clicked="onCellClicked">

      <!-- Pass on all scoped slots -->
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" scope="props">
        <slot :name="slot" v-bind="props"/>
      </template>
    </vuetable>
    <div v-if="!disablePagination" class="vuetable-pagination">
      <vuetable-pagination-info class="pull-left" ref="paginationInfo" info-class="pagination-info"></vuetable-pagination-info>
      <vue-table-pagination-custom class="pull-right" ref="pagination" @vuetable-pagination:change-page="onChangePage"></vue-table-pagination-custom>
    </div>
  </div>
</template>

<script>

import VueTablePaginationCustom from './VueTablePaginationCustom'
import Sortable from 'sortablejs'
export default {
  components: {
    VueTablePaginationCustom
  },
  props: {
    perPage: {
      type: Number,
      default: 50,
      required: false
    },
    onCheckboxToggled: {
      type: Function,
      default: () => {},
      required: false
    },
    disablePagination: {
      type: Boolean,
      default: false,
      required: false
    },
    sortable: {
      type: Boolean,
      default: false,
      required: false
    },
    onRowClass: {
      type: Function,
      default: () => {},
      required: false
    },
    sortableFunction: {
      type: Function,
      default: () => {},
      required: false
    },
    classes: {
      type: String,
      default: 'custom-vue-table-container'
    },
    extraCss: {
      type: Object,
      default: () => { return {table: ''} }
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: null
    },
    fields: {
      type: Array,
      required: true
    },
    dataVar: {
      type: Array
    },
    moreParams: {
      required: false
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    detailRowComponent: {
      type: String,
      required: false
    },
    detailRowId: {
      type: String,
      required: false
    },
    trackBy: {
      type: String,
      required: false
    }
  },
  data: function () {
    return {
      sortObject: null,
      isLoading: false,
      css: {
        table: {
          handleIcon: 'fa fa-bars text-secondary'
        }
      },
      tokenHeader: {
        headers: {'Authorization': 'Bearer ' + this.$auth.token()}
      }
    }
  },
  methods: {
    onLoading: function () {
      if (this.apiMode) {
        this.isLoading = true
      }
    },
    loadError: function () {
      this.isLoading = false
    },
    loadSuccess: function () {
      this.isLoading = false
      this.$emit('load-success', this.$refs.vuetable.tableData)
      console.log('Data reloaded')
      var vm = this
      if (this.sortObject === null && this.sortable === true) {
        this.sortObject = new Sortable(this.$refs.vuetable.$el.querySelector('tbody'), {
          handle: '.handle-icon',
          dataIdAttr: 'item-index',
          onEnd: function (evt) {
            var order = vm.sortObject.toArray()
            var newOrder = []
            var tableData = vm.$refs.vuetable.tableData
            for (var i = 0; i < order.length; i++) {
              newOrder.push({newOrder: i + 1, oldOrder: order[i], id: tableData[order[i]].id, name: tableData[order[i]].free_text})
            }
            vm.$emit('sortChanged', newOrder)
          }
        })
      }
      /* this.$notify({
        group: 'full',
        text: this.$t('Data reloaded'),
        position: 'top center'
      }) */
    },
    onChangePage: function (page) {
      this.$refs.vuetable.changePage(page)
    },
    onPaginationData: function (paginationData) {
      if (!this.disablePagination) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      }
    },
    onTableSwitchEvent: function (data) {
      this.$emit('table-switch-event', data)
    },
    onCellClicked: function (data, field, event) {
      this.$emit('vuetable:cell-clicked', data, field, event)
      if (this.detailRowComponent && this.detailRowId) {
        this.$refs.vuetable.toggleDetailRow(data.data[this.detailRowId])
      }
    }
  },
  watch: {
    moreParams: function () {
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  events: {
    'refresh-table-data' () {
      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    'filter-set' (filterText) {
      this.moreParams = {
        filter: filterText
      }
      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    'filter-reset' () {
      this.moreParams = {}
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  }
}
</script>
<style>
  .custom-action-buttons-td { position:absolute; right: 0; border: 0 !important}
  .custom-vue-table table tr td { height: 45px }
  .custom-vue-table-wrapper { position: relative; }
  .table-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
  }
  .table-loading-spinner {
    text-align: center;
    color: #666;
  }
  .table-loading-text {
    margin-top: 10px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// CustomVueTable.vue?db0ec734